const routerConfig = {
  home: '/',
  register: '/register',
  searchResult: '/search_result',
  tourPage: '/tour',
  profile: '/profile',
  cart: '/cart',
  booking: '/booking',
  ordersList: '/orders_list',
  orderDetails: '/order_details',
  vendor: {
    home: '/vendor',
    newTour: '/vendor/create_tour',
    editTour: '/vendor/edit_tour',
  },
  errorPayment: '/error_payment',
  resetPassword: '/reset-password',
  contactUs: "/contact_us",
  aboutUs: '/about_us',
};

export default routerConfig;



// WEBPACK FOOTER //
// ./src/app/config/router.js